import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { TranslationService } from '../../../../services/translation.service';

declare let $: any;

@Component({
    selector : 'app-screen',
    templateUrl:'appscreen-component.html'
})
export class AppScreenComponent implements OnInit, OnDestroy{

  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService) {
  }

  public admin=false
  public ngOnInit(): any {
    let event=this._appData.event;
    let user=this._appData.instagramUser;
    event.admins.forEach(val=>{
      if (val==user.uid){
        this._appData.admin=true;
        this.admin=true;
      }
    })
    this._appData.room.admin.forEach(val=>{
      if (val==user.uid){
        this._appData.admin=true;
        this.admin=true;
      }
    })

  }
  public openRoomEditModal(){
    $('#editRoomModal').modal("show");
    $('#editRoomModalClick').click();
    
  }
  public openScreen(screen){

    this._appData.cellScreen=screen;
    $('#editRoomModalClick').click();

  }

  public ngOnDestroy() : any {
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/app-screen/appscreen-component.ts